<template>
  <v-container>
    <div class="wrapHeading">
      <h1 class="headingOnlinerechner">Passberechtigt</h1>
      <hr class="dividerHeading" />
    </div>

    <div class="wrapText">
      <p>
        Wenn Sie ALG II (SBG II), Sozialhilfe (SGB XII), Wohngeld, Leistungen
        nach dem AsylbLG oder Kinderzuschlag beziehen oder in einer betreuten
        Wohnform nach SGB VIII leben, sind Sie dazu berechtigt, die vielfältigen
        Möglichkeiten des Karlsruher Pass zu nutzen.
      </p>

      <h3>Zu den Angeboten in der Region Karlsruhe</h3>
      <v-row>
        <div id="mobilitaetOnHover">
          <a
            href="http://karlsruher-pass.de/angebote/#/?category=mobilitaet-de"
          >
            <img
              src="/wp-content/uploads/2017/08/Mobilitaet-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Mobilitaet.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Mobilitaet-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=sport-de">
            <img
              src="/wp-content/uploads/2017/08/Sport-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Sport.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Sport-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=freizeit-de">
            <img
              src="/wp-content/uploads/2017/08/Freizeit-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Freizeit.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Freizeit-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=musik-de">
            <img
              src="/wp-content/uploads/2017/08/Musik-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Musik.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Musik-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=theater-de">
            <img
              src="/wp-content/uploads/2017/08/Theater-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Theater.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Theater-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=bildung-de">
            <img
              src="/wp-content/uploads/2017/08/Bildung-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Bildung.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Bildung-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=einkaufen-de">
            <img
              src="/wp-content/uploads/2017/08/Einkaufen-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Einkaufen.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Einkaufen-trans.png';"
            />
          </a>
        </div>
        <div id="mobilitaetOnHover">
          <a href="http://karlsruher-pass.de/angebote/#/?category=essen-de">
            <img
              src="/wp-content/uploads/2017/08/Essen-trans.png"
              onmouseover="this.src='/wp-content/uploads/2017/12/Button-Text-Essen.png';"
              onmouseout="this.src='/wp-content/uploads/2017/08/Essen-trans.png';"
            />
          </a>
        </div>
      </v-row>
    </div>
  </v-container>
</template>


<script>
export default {};
</script>

<style >
.wrapHeading {
  margin-top: 30px;
}
.wrapText {
  margin-top: 70px;
}
.headingOnlinerechner {
  letter-spacing: 3px;
}
.dividerHeading {
  width: 300px;
  float: left;
  height: 2px;
  background-color: #fff;
}
</style>